import { Component, AfterViewInit, ElementRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormComponentLookup, FormEntryComponentClass } from '@ptl/forms';
import { HTTPWrapperContext, RequestConfigImplementation, REQUEST_METHODS, XHR_STRATEGIES } from '@ptl/xhr';
import { HttpHeaders } from '@angular/common/http';
import { FormConfigUtilityService } from '../../../services/filterByConfigMetatags/form-config-utility.service';
import { ContentStorageService } from '@ptl/global-components';
import { PlanUtilityService } from '../../../../plan-selection/plan-summary-list/plan-utility.service';

@FormComponentLookup('statements-of-authorization')
@Component({
    selector: 'app-statements-of-authorization',
    templateUrl: './statements-of-authorization.component.html',
    styleUrls: ['./statements-of-authorization.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class StatementsOfAuthorizationComponent extends FormEntryComponentClass implements AfterViewInit {
  @ViewChild('entryRef') entryRef: ElementRef;
  value: any = [];

  soaContent: string;

  constructor(
    private httpClient: HTTPWrapperContext,
    private formConfigUtility: FormConfigUtilityService,
    private contentStorage: ContentStorageService,
    private planUtilityService: PlanUtilityService) {
    super();
  }

  ngOnInit() { }

  ngAfterViewInit(): void {
    this.initTriggers();
    this.getStatementsOfAuthorization();
  }

  async getStatementsOfAuthorization() {

    const strategyMap: Map<string, any> = new Map();
    strategyMap.set("hardcoded", false);
    strategyMap.set("metaTagPriorityByIndex", this.entry.custom.metaTagPriorityByIndex || '');
    strategyMap.set("url", this.entry.custom.soaMapUrl);

    this.contentStorage.storeContentMapFromComponent(this.entry.custom.soaStrategy, strategyMap);

    // Get a formMaps.json for SOA
    // Filter by Plan type and state selected
    // return the JSONMAP url
    // Join the arrays to make it easier to edit.
    const soaMapConfig = await this.formConfigUtility.getJsonFormConfig(this.entry.custom.soaStrategy) as any;
    const soaFile = await this.getJsonMap(soaMapConfig.url) as any;
    const soaJoined = soaFile.join("");

    // Replace <<planName>> with actual plan name value
    const planName = this.planUtilityService.getSelectedPlan()?.productName;
    this.soaContent = soaJoined.replace(new RegExp('<<planName>>', 'g'), planName ? planName : 'Plan');
  }

  getJsonMap(url: string) {

    const requestConfig = new RequestConfigImplementation({
      method: REQUEST_METHODS.GET,
      url: url,
      headers: new HttpHeaders({})
    });

    this.httpClient.setStrategy(XHR_STRATEGIES.MOCK);
    return this.httpClient.makeRequest(requestConfig);

  }

}
